<div class="dashboard-container">
  @if (notificationBanners.size > 0 || buttonBanners.size > 0) {
    <div class="banner-grid">
      @for (
        notificationBanner of notificationBanners;
        track notificationBanner
      ) {
        <app-notification-banner
          (bannerClose)="archiveBanner($event)"
          [notificationBanner]="notificationBanner"
        ></app-notification-banner>
      }
      @for (buttonBanner of buttonBanners; track buttonBanner) {
        <app-button-banner
          (bannerButtonClick)="bannerButtonClick($event)"
          [buttonBanner]="buttonBanner"
        ></app-button-banner>
      }
    </div>
  }

  <div [ngClass]="dashboardWidgetInfoGroup.class" class="widgets-grid">
    @if (showWidgetsButton) {
      <div class="show-all-cell">
        <button class="btn btn-outline show-widgets" (click)="showAllWidgets()">
          Show all dashboard widgets
        </button>
      </div>
    }
    <ng-container
      *ngTemplateOutlet="
        WidgetInfoCollection;
        context: { widgetItems: dashboardWidgetInfoGroup.widgetInfoCollection }
      "
    ></ng-container>
    <ng-template #WidgetInfoCollection let-widgetItems="widgetItems">
      @for (widgetItem of widgetItems; track widgetItem) {
        @if (widgetItem.show) {
          <div [ngClass]="widgetItem.class">
            @if (isWidgetInfoGroup(widgetItem)) {
              <ng-container [ngTemplateOutlet]="widgetGroup"></ng-container>
            }
            <ng-template #widgetGroup>
              <ng-container
                *ngTemplateOutlet="
                  WidgetInfoCollection;
                  context: { widgetItems: widgetItem.widgetInfoCollection }
                "
              ></ng-container>
            </ng-template>
            @if (!isWidgetInfoGroup(widgetItem)) {
              <ng-container [ngTemplateOutlet]="widgetInfo"></ng-container>
            }
            <ng-template #widgetInfo>
              <ng-template
                [widgetInfo]="widgetItem"
                [VendorId]="VendorId"
                [CompanyId]="CompanyId"
                appWidgetContainer
              ></ng-template>
            </ng-template>
          </div>
        }
      }
    </ng-template>
  </div>
</div>
